// import React, { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom';
// import { Apirequests } from '../../utils/ApiRequests';
// import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
// import SpinningLogo from '../../components/Spinner';
// import CustomPageHeader from '../../components/CustomPageHeader';
// import { downloadExcel } from '../../utils/DownloadXls';
// import Table from '../../components/Table';
// import moment from 'moment';
// import BtnSpinner from '../../components/BtnSpinner';
// import { Edit3, Trash } from 'lucide-react';
// import Pagination from '../../components/Pagination';
// import CustomOffCanvas from '../../components/CustomOffCanvas';
// import OrderDetails from './OrderDetails';
// import CreateOrder from './CreateOrder';
// import EditOrder from './EditOrder';

// function Orders() {
//   const [orders, setOrders] = useState(null);
//   const [loading, setLoading] = useState({ state: false, name: "" });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [refresh, setRefresh] = useState(false);
//   const [currentOrder, setCurrentOrder] = useState(null);
//   const [deleteId, setdeleteId] = useState(null);
//   const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });


//   const token = localStorage.getItem("token");


//   const totalItems = orders?.length; // Total number of items
//   const itemsPerPage = 10;

//   const currentData = React.useMemo(() => {
//     return orders?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) || [];
//   }, [orders, currentPage]);

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   const navigate = useNavigate();

//   const handleRefresh = () => setRefresh(!refresh)

//   const handleSearch = async () => {
//     if (!searchTerm) {
//       return ErrorTost("Enter a key to serach")
//     }

//     if(currentPage!==1){
//       setCurrentPage(1)
//     }

//     // console.log('term',searchTerm,'search')
//     await fetchOrders(searchTerm)
//   };


//   const fetchOrders = async () => {
//     setLoading({ state: true, name: 'fetchorders' })
//     try {
//       const orderRes = await Apirequests(`orders/get-orders?q=${searchTerm}`,
//         "GET",
//         {},
//         {
//           Authorization: `Bearer ${token}`,
//         });

//       // console.log(orderRes,'orderres')

//       if (orderRes?.success) {
//         setOrders(orderRes?.data)
//       }
//     } catch (error) {
//       console.log(error, 'fetch users error');
//       return ErrorTost("Something went wrong. Try again later.")
//     }
//     setLoading({ state: false, name: "" })
//   }

//   const handleDeleteOrder = async (orderid) => {
//     setLoading({ state: true, name: "deleteorder" });
//     setdeleteId(orderid)
//     try {
//       const delRes = await Apirequests(`orders/delete-order/${orderid}`, 'DELETE', {}, {
//         Authorization: `Bearer ${token}`
//       });
//       if (delRes?.success) {
//         SuccessTost(delRes?.message || "order deleted successfully");
//         setRefresh((prev) => !prev);
//       } else {
//         ErrorTost(delRes?.message)
//       }
//     } catch (error) {
//       console.log(error, 'delete order error');
//       ErrorTost("Something went wrong, please try again later. ")
//     }
//     setLoading({ state: false, name: "" })
//   };



//   useEffect(() => {
//     fetchOrders();
//   }, [refresh, token]);

//   // console.log(currentData,orders,'orders')



//   if (loading.state && loading.name === "fetchorders") {
//     return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
//       <SpinningLogo />
//     </div>
//   }



//   return (
//     <div>
//       <CustomPageHeader
//         title={"Orders"}
//         text={searchTerm}
//         setText={setSearchTerm}
//         handleSearch={handleSearch}
//         onClick={() => setIsOffCanvasOpen({ state: true, name: "createorder" })}
//         btnText={"Add Order"}
//         handleBackClick={() => navigate("/")}
//         handleRefresh={handleRefresh}
//         handleDownload={() => downloadExcel(orders, 'orders')}
//       />
//       <main className="mx-auto py-6 sm:px-6 lg:px-8">
//         <div className="px-4 py-6 sm:px-0">
//           <div className="overflow-x-auto">
//             <Table
//               tableHead={

//                 <tr>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Order Id</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Currency</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Crated At</th>
//                   <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                 </tr>
//               }
//               tableBody={
//                 currentData?.map((order, i) =>
//                   <tr key={i}>
//                     <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: 'vieworderdetails' }); setCurrentOrder(order) }}>{order?.order_id || "not available"}</span></td>
//                     <td className="px-6 py-4 whitespace-nowrap">{order?.user_id?.email || order?.notes?.email || "not available"}</td>
//                     <td className="px-6 py-4 whitespace-nowrap"><span className={`${order?.status === "captured" ? "bg-green-200" : "bg-red-200"} px-3 py-2 rounded-full`}>{order?.status}</span></td>
//                     <td className="px-6 py-4 whitespace-nowrap">{order?.notes?.currency || "INR"}</td>
//                     <td className="px-6 py-4 whitespace-nowrap">{order?.amount}</td>
//                     <td className="px-6 py-4 whitespace-nowrap">{moment(order?.createdAt).format('DD-MM-YY hh:mm a')}</td>
//                     <td className="px-6 py-4 whitespace-nowrap flex gap-3">
//                       <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteOrder(order?._id)}>
//                         {
//                           loading.state && loading.name === "deleteorder" && deleteId === order?._id ?
//                             <BtnSpinner /> :
//                             <>
//                               <Trash className='text-red-700 text-sm' size={20} />
//                               <span className='text-red-700 text-sm'>Delete</span>
//                             </>
//                         }

//                       </button>

//                       <button className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editorder" }); setCurrentOrder(order) }}><Edit3 size={18} /> Edit</button>
//                     </td>
//                   </tr>)
//               }
//             />
//           </div>
//         </div>
//         {orders?.length ?
//           <div className="flex gap-x-2 items-center justify-between">
//             <p>total: {orders?.length}</p>
//             <Pagination
//               page={currentPage}
//               totalItems={totalItems}
//               itemsPerPage={itemsPerPage}
//               onPageChange={handlePageChange}
//             />
//           </div> : null}
//       </main>

//       <CustomOffCanvas
//         open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "vieworderdetails"}
//         close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentOrder(null) }}
//         content={
//           <OrderDetails
//             close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentOrder(null) }}
//             setRefresh={setRefresh}
//             order={currentOrder}
//           />
//         }
//       />

//       <CustomOffCanvas
//         open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "createorder"}
//         close={() => setIsOffCanvasOpen({ state: false, name: "" })}
//         content={
//           <CreateOrder
//             close={() => setIsOffCanvasOpen({ state: false, name: "" })}
//             setRefresh={setRefresh}
//           />
//         }
//       />


//       <CustomOffCanvas
//         open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editorder"}
//         close={() => setIsOffCanvasOpen({ state: false, name: "" })}
//         content={
//           <EditOrder
//             close={() => setIsOffCanvasOpen({ state: false, name: "" })}
//             setRefresh={setRefresh}
//             order={currentOrder}
//           />
//         }
//       />
//     </div>
//   )
// }

// export default Orders




import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit3, Search, Trash, X } from 'lucide-react';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel, downloadOrdersExcel } from '../../utils/DownloadXls';
import Table from '../../components/Table';
import BtnSpinner from '../../components/BtnSpinner';
import Pagination from '../../components/Pagination';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import OrderDetails from './OrderDetails';
import CreateOrder from './CreateOrder';
import EditOrder from './EditOrder';

function Orders() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState({ state: false, name: '' });
  const [refresh, setRefresh] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: '' });

  const [filters, setFilters] = useState({
    q: '',
    status: '',
    product_id: '',
    order_id: '',
    user: '',
    month: '',
    year: '',
  });

  const [appliedFilters, setAppliedFilters] = useState({
    q: '',
    status: '',
    product_id: '',
    order_id: '',
    user: '',
    month: '',
    year: '',
  });

  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  });

  const monthOptions = useMemo(
    () => [
      { label: 'All Months', value: '' },
      { label: 'January', value: '1' },
      { label: 'February', value: '2' },
      { label: 'March', value: '3' },
      { label: 'April', value: '4' },
      { label: 'May', value: '5' },
      { label: 'June', value: '6' },
      { label: 'July', value: '7' },
      { label: 'August', value: '8' },
      { label: 'September', value: '9' },
      { label: 'October', value: '10' },
      { label: 'November', value: '11' },
      { label: 'December', value: '12' },
    ],
    []
  );

  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [{ label: 'All Years', value: '' }];
    for (let year = currentYear; year >= 2020; year--) {
      years.push({ label: `${year}`, value: `${year}` });
    }
    return years;
  }, []);

  const formatISTDate = (date) => {
    if (!date) return 'not available';

    const formatted = new Date(date).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return formatted.replace(/-/g, '/');
  };

const extractUserDisplay = (order) => {
  if (order?.user_details?.email) return order.user_details.email;
  if (order?.notes?.email) return order.notes.email;
  if (order?.user) return order.user;
  return 'not available';
};

  const buildQueryString = useCallback((page = 1, limit = pagination.limit) => {
    const params = new URLSearchParams();

    params.append('page', page);
    params.append('limit', limit);

    Object.entries(appliedFilters).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        params.append(key, value);
      }
    });

    return params.toString();
  }, [appliedFilters, pagination.limit]);

  const fetchOrders = useCallback(async (page = 1) => {
    setLoading({ state: true, name: 'fetchorders' });

    try {
      const queryString = buildQueryString(page);
      const orderRes = await Apirequests(
        `orders/get-orders-advanced?${queryString}`,
        'GET',
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (orderRes?.success) {
        setOrders(orderRes?.data || []);
        setPagination({
          total: orderRes?.pagination?.total || 0,
          page: orderRes?.pagination?.page || page,
          limit: orderRes?.pagination?.limit || 10,
          totalPages: orderRes?.pagination?.totalPages || 0,
        });
      } else {
        setOrders([]);
        ErrorTost(orderRes?.message || 'Failed to fetch orders');
      }
    } catch (error) {
      console.log(error, 'fetch orders error');
      ErrorTost('Something went wrong. Try again later.');
      setOrders([]);
    }

    setLoading({ state: false, name: '' });
  }, [buildQueryString, token]);

  const handleSearch = async () => {
    if ((filters.month && !filters.year) || (!filters.month && filters.year)) {
      return ErrorTost('Please select both month and year');
    }

    setAppliedFilters(filters);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handleClearFilters = () => {
    const resetFilters = {
      q: '',
      status: '',
      product_id: '',
      order_id: '',
      user: '',
      month: '',
      year: '',
    };

    setFilters(resetFilters);
    setAppliedFilters(resetFilters);
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleRefresh = () => {
    setRefresh((prev) => !prev);
  };

  const handleDeleteOrder = async (orderid) => {
    setLoading({ state: true, name: 'deleteorder' });
    setDeleteId(orderid);

    try {
      const delRes = await Apirequests(`orders/delete-order/${orderid}`, 'DELETE', {}, {
        Authorization: `Bearer ${token}`
      });

      if (delRes?.success) {
        SuccessTost(delRes?.message || 'order deleted successfully');
        setRefresh((prev) => !prev);
      } else {
        ErrorTost(delRes?.message || 'Failed to delete order');
      }
    } catch (error) {
      console.log(error, 'delete order error');
      ErrorTost('Something went wrong, please try again later.');
    }

    setLoading({ state: false, name: '' });
    setDeleteId(null);
  };


  const handleDownloadOrders = async () => {
  try {
    setLoading({ state: true, name: 'downloadorders' });

    const params = new URLSearchParams();

    Object.entries(appliedFilters).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        params.append(key, value);
      }
    });

    params.append('page', 1);
    params.append('limit', 5000);

    const res = await Apirequests(
      `orders/get-orders-advanced?${params.toString()}`,
      'GET',
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );

    if (res?.success) {
      downloadOrdersExcel(res?.data || [], 'orders');
    } else {
      ErrorTost(res?.message || 'Failed to download orders');
    }
  } catch (error) {
    ErrorTost('Something went wrong while downloading orders');
  }

  setLoading({ state: false, name: '' });
};

  useEffect(() => {
    fetchOrders(pagination.page);
  }, [fetchOrders, pagination.page, refresh]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, page: 1 }));
  }, [appliedFilters]);

  if (loading.state && loading.name === 'fetchorders' && orders.length === 0) {
    return (
      <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
        <SpinningLogo />
      </div>
    );
  }

  return (
    <div>
      <CustomPageHeader
        title={'Orders'}
        text={filters.q}
        setText={(value) => setFilters((prev) => ({ ...prev, q: value }))}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: 'createorder' })}
        btnText={'Add Order'}
        handleBackClick={() => navigate('/')}
        handleRefresh={handleRefresh}
        handleDownload={handleDownloadOrders}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">General Search</label>
                <input
                  type="text"
                  value={filters.q}
                  onChange={(e) => setFilters((prev) => ({ ...prev, q: e.target.value }))}
                  placeholder="Search order, status, product, user"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                <select
                  value={filters.status}
                  onChange={(e) => setFilters((prev) => ({ ...prev, status: e.target.value }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">All Status</option>
                  <option value="created">Created</option>
                  <option value="paid">Paid</option>
                  <option value="captured">Captured</option>
                  <option value="failed">Failed</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Course / Product ID</label>
                <input
                  type="text"
                  value={filters.product_id}
                  onChange={(e) => setFilters((prev) => ({ ...prev, product_id: e.target.value }))}
                  placeholder="Enter product id"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Order ID</label>
                <input
                  type="text"
                  value={filters.order_id}
                  onChange={(e) => setFilters((prev) => ({ ...prev, order_id: e.target.value }))}
                  placeholder="Enter order id"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">User</label>
                <input
                  type="text"
                  value={filters.user}
                  onChange={(e) => setFilters((prev) => ({ ...prev, user: e.target.value }))}
                  placeholder="Name / Email / Phone"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Month</label>
                <select
                  value={filters.month}
                  onChange={(e) => setFilters((prev) => ({ ...prev, month: e.target.value }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {monthOptions.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Year</label>
                <select
                  value={filters.year}
                  onChange={(e) => setFilters((prev) => ({ ...prev, year: e.target.value }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {yearOptions.map((year) => (
                    <option key={year.value} value={year.value}>
                      {year.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rows Per Page</label>
                <select
                  value={pagination.limit}
                  onChange={(e) =>
                    setPagination((prev) => ({
                      ...prev,
                      limit: Number(e.target.value),
                      page: 1,
                    }))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-4">
              <button
                onClick={handleSearch}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
              >
                <Search size={18} />
                Search
              </button>

              <button
                onClick={handleClearFilters}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200"
              >
                <X size={18} />
                Clear Filters
              </button>
            </div>
          </div>

          <div className="overflow-x-auto">
            <Table
              tableHead={
                <tr>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Order Id</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Currency</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At (IST)</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              }
              tableBody={
                orders?.length ? (
                  orders.map((order, i) => (
                    <tr key={order?._id || i}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className='text-indigo-600 cursor-pointer'
                          onClick={() => {
                            setIsOffCanvasOpen({ state: true, name: 'vieworderdetails' });
                            setCurrentOrder(order);
                          }}
                        >
                          {order?.order_id || 'not available'}
                        </span>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {extractUserDisplay(order)}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-3 py-2 rounded-full text-sm ${
                            order?.status === 'captured' || order?.status === 'paid'
                              ? 'bg-green-200 text-green-800'
                              : order?.status === 'failed'
                              ? 'bg-red-200 text-red-800'
                              : 'bg-yellow-200 text-yellow-800'
                          }`}
                        >
                          {order?.status || 'not available'}
                        </span>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {order?.notes?.currency || 'INR'}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {order?.amount ?? 'not available'}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {formatISTDate(order?.createdAt)}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap flex gap-3">
                        <button
                          className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1'
                          onClick={() => handleDeleteOrder(order?._id)}
                        >
                          {loading.state && loading.name === 'deleteorder' && deleteId === order?._id ? (
                            <BtnSpinner />
                          ) : (
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                          )}
                        </button>

                        <button
                          className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1'
                          onClick={() => {
                            setIsOffCanvasOpen({ state: true, name: 'editorder' });
                            setCurrentOrder(order);
                          }}
                        >
                          <Edit3 size={18} />
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="px-6 py-10 text-center text-gray-500">
                      No orders found
                    </td>
                  </tr>
                )
              }
            />
          </div>
        </div>

        {pagination.total > 0 && (
          <div className="flex gap-x-2 items-center justify-between">
            <p>
              total: {pagination.total} | page: {pagination.page} of {pagination.totalPages || 1}
            </p>
            <Pagination
              page={pagination.page}
              totalItems={pagination.total}
              itemsPerPage={pagination.limit}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </main>

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === 'vieworderdetails'}
        close={() => {
          setIsOffCanvasOpen({ state: false, name: '' });
          setCurrentOrder(null);
        }}
        content={
          <OrderDetails
            close={() => {
              setIsOffCanvasOpen({ state: false, name: '' });
              setCurrentOrder(null);
            }}
            setRefresh={setRefresh}
            order={currentOrder}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === 'createorder'}
        close={() => setIsOffCanvasOpen({ state: false, name: '' })}
        content={
          <CreateOrder
            close={() => setIsOffCanvasOpen({ state: false, name: '' })}
            setRefresh={setRefresh}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === 'editorder'}
        close={() => setIsOffCanvasOpen({ state: false, name: '' })}
        content={
          <EditOrder
            close={() => setIsOffCanvasOpen({ state: false, name: '' })}
            setRefresh={setRefresh}
            order={currentOrder}
          />
        }
      />
    </div>
  );
}

export default Orders;